import { BaggageType } from '@websky/graphql';

import { Baggage, Measurement } from '../../../../../BaggageService/types';
import { GdsAggregationSelectedService } from '../../../../../Checkout/types';

type Translate = (key: string) => string;

interface BaggageTexts {
	baggageTexts: string[];
	carryOnTexts: string[];
}

const toTexts = (services: Map<string, number>, t: Translate): string[] =>
	Array.from(services, ([size, count]) => (size ? `${size}, ${count} ${t('pc')}` : `${count} ${t('pc')}`));

export const getBaggageTexts = (selectedServices: GdsAggregationSelectedService[], t: Translate): BaggageTexts => {
	const baggageServicesMap = new Map<string, number>();
	const carryOnServicesMap = new Map<string, number>();

	selectedServices.forEach(({ service, count }) => {
		const baggage = service as Baggage;
		const isWeightBased = baggage.value.measurement !== Measurement.Pieces;
		const size = isWeightBased ? `${baggage.value.amount} ${t(baggage.value.measurement)}` : '';
		const services = baggage.type === BaggageType.CarryOn ? carryOnServicesMap : baggageServicesMap;

		services.set(size, (services.get(size) || 0) + count);
	});

	return {
		baggageTexts: toTexts(baggageServicesMap, t),
		carryOnTexts: toTexts(carryOnServicesMap, t)
	};
};
